export default function SocialEuroOutline() {
  return (
    <div
      className="ion-icon-social-euro-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M310.143,64c31.337,0,59.096,2.607,88.137,8.364l-5.06,34.148c-29.405-4.319-55.659-6.429-79.853-6.429
		c-35.025,0-58.535,6.153-74.129,19.365C220.142,135.627,218,158.428,218,174.17v2.33V193h15.867h120.184l-2.383,16H233.867H218
		v15.5v48V289h15.867h105.885l-2.384,16H233.867H218v15.5v12.33c0,19.546,2.338,44.061,21.084,60.274
		c15.042,13.01,37.921,18.812,74.258,18.812c24.534,0,50.197-2.055,79.771-6.42l5.014,34.138
		c-29.031,5.759-56.741,8.366-87.977,8.366c-52.591,0-91.43-9.08-115.565-26.987C172.615,404.711,162,380.361,162,346.57V320.5V305
		h-16.133H112v-16h33.867H162v-16.5v-48V209h-16.133H112v-16h33.867H162v-16.5v-11.07c0-33.791,10.613-58.142,32.582-74.442
		C218.715,73.08,257.552,64,310.143,64 M310.209,48C195.479,48,146,89.225,146,165.43V177H96v48h50v48H96v48h50v25.57
		C146,422.774,195.481,464,310.211,464c35.25,0,67.777-3.123,105.789-11.866l-9.411-64.96c-37.323,6.244-66.942,8.742-93.206,8.742
		c-64.275,0-79.383-18.739-79.383-63.086V321h117.162l7.148-48H234v-48h131.461l7.149-48H234v-2.83
		c0-35.92,15.159-58.086,79.434-58.086c26.264,0,55.959,2.498,93.281,8.742L416,60C377.988,51.257,345.458,48,310.209,48L310.209,48
		z"/>
</g>
</svg>
`,
      }}
    />
  )
}
